export const isRentalTabReselection = (
  selectedCategory: number,
  activeCategory: number,
  categoryCount: number,
  rentalEnabled: boolean
): boolean =>
  rentalEnabled &&
  selectedCategory === categoryCount &&
  selectedCategory === activeCategory;
